export default __webpack_public_path__ + "static/olympicPark7-6adf8a5f1948e9facda04b4cda9bb2a0.jpeg";